"use client";

import clsx from "clsx";

interface OnboardingStepHeaderProps {
  title: string;
  description?: string;
  className?: string;
}

export function OnboardingStepHeader({
  title,
  description,
  className,
}: Readonly<OnboardingStepHeaderProps>) {
  return (
    <div className={clsx("max-w-3xl mx-auto text-center", className)}>
      <h1 className="text-[28px] font-medium">{title}</h1>
      {description && (
        <p className="max-w-xl mx-auto text-[16px] text-500">{description}</p>
      )}
    </div>
  );
}
